<template>
  <v-select
    :items="estados"
    item-text="uf"
    item-value="uf"
    no-data-text="Nenhuma UF encontrada"
    label="UF"
    v-model="ufModel"
    :dense="dense"
    :disabled="disabled"
    :loading="estadoLoading"
  ></v-select>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  props: {
    dense: Boolean,
    disabled: Boolean,
  },
  watch: {
    estadoSelec: async function () {
      await this.getMunicipios();
    },
  },
  computed: {
    ...mapState("locais", ["estados", "estadoSelec", "estadoLoading"]),
    ufModel: {
      get: function () {
        return this.estadoSelec;
      },
      set: function (value) {
        this.setEstadoSelec(value);
      },
    },
  },
  methods: {
    ...mapActions("locais", ["getMunicipios"]),
    ...mapMutations("locais", ["setEstadoSelec"]),
  },
};
</script>

<style>
</style>